if (!customElements.get('product-modal')) {
  const PRODUCT_MODAL_ZOOM_RATIO = 1.5;

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.updateImageWidth(opener);
        super.show(opener);
        this.showActiveMedia();
      }

      updateImageWidth(opener) {
        const isProductPage = opener.closest('product-info')?.dataset.updateUrl === 'true';
        const sourceImage = isProductPage
          ? opener.closest('modal-opener')?.querySelector('.product__media img')
          : null;
        const sourceWidth = sourceImage?.getBoundingClientRect().width;
        const hasProductPageZoom = Boolean(sourceWidth);
        this.toggleAttribute('data-product-page-zoom', hasProductPageZoom);

        if (!hasProductPageZoom) {
          this.style.removeProperty('--product-modal-image-width');
          return;
        }

        this.style.setProperty('--product-modal-image-width', `${sourceWidth * PRODUCT_MODAL_ZOOM_RATIO}px`);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
